import React from 'react';

import Masthead from '@bd-uikit-web/React/Masthead';

import './header.scss';

export default class Header extends Masthead {
  render() {
    return (
      <header className="header">
        <div className="header__inner">
          <button className =
            "header__hamburger ion-android-menu" onClick = {() => this.props.onMenuClick()}
          >
          </button>
          <a href="http://blackdove.com/" target="_blank">
            <img className="header__logo" src="/assets/img/bd-logo-dark-text.svg"
              alt="Blackdove Logo"
            />
          </a>

          <nav className="header__nav">
            <ul className="list--inline list--spacing-no">
              {/* <li>
                  <a href="https://shop.blackdove.com/" target="_blank">
                  Store
                    <span className="header__icon ion-bag "></span>
                  </a>
                </li> */}
              <li>
                <a href="https://artist.blackdove.com/register" target="_blank">
                  <span className="header__icon ion-easel"></span>
                    Artist Portal
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    );
  }
}
